import React from 'react'
import {
  PaginationBar,
  PerPageGroup,
  PerPageSelect,
  ResultsInfo,
  PageButtons,
  PageBtn,
  Ellipsis,
  PerPageWrapper,
} from './styled.components'

const PER_PAGE_OPTIONS = [10, 25, 50, 100]

function buildPageRange(current, total) {
  if (total <= 7) return Array.from({length: total}, (_, i) => i + 1)

  const pages = []
  if (current <= 5) {
    pages.push(1, 2, 3, 4, 5, '...', total)
  } else if (current >= total - 4) {
    pages.push(1, '...', total - 4, total - 3, total - 2, total - 1, total)
  } else {
    pages.push(1, '...', current - 1, current, current + 1, '...', total)
  }
  return pages
}

function ProposalPagination({
  currentPage,
  totalItems,
  perPage,
  onPageChange,
  onPerPageChange,
}) {
  const totalPages = Math.ceil(totalItems / perPage)
  const start = (currentPage - 1) * perPage + 1
  const end = Math.min(currentPage * perPage, totalItems)
  const pages = buildPageRange(currentPage, totalPages)

  return (
    <PaginationBar>
      <PageButtons>
        <PageBtn
          type="button"
          disabled={currentPage === 1}
          onClick={() => onPageChange(1)}
        >
          &laquo; First
        </PageBtn>
        <PageBtn
          type="button"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          &lsaquo; Back
        </PageBtn>

        {pages.map((p, i) =>
          p === '...' ? (
            <Ellipsis key={`ellipsis-${i}`}>···</Ellipsis>
          ) : (
            <PageBtn
              key={p}
              type="button"
              active={p === currentPage}
              onClick={() => onPageChange(p)}
            >
              {p}
            </PageBtn>
          ),
        )}

        <PageBtn
          type="button"
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next &rsaquo;
        </PageBtn>
        <PageBtn
          type="button"
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(totalPages)}
        >
          Last &raquo;
        </PageBtn>
      </PageButtons>

      <PerPageWrapper>
        <PerPageGroup>
          Result per page
          <PerPageSelect
            value={perPage}
            onChange={e => onPerPageChange(Number(e.target.value))}
          >
            {PER_PAGE_OPTIONS.map(n => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </PerPageSelect>
        </PerPageGroup>
        <ResultsInfo>
          <strong>{start.toLocaleString()}</strong>-
          <strong>{end.toLocaleString()}</strong> of{' '}
          <strong>{totalItems.toLocaleString()}</strong>
        </ResultsInfo>
      </PerPageWrapper>
    </PaginationBar>
  )
}

export {ProposalPagination}
